module.exports = __webpack_public_path__ + "static/media/bg.2f6fd03a.jpg";